define('views/modules/profile/edit/personal-info-edit-panel',[
    // Libs
    'underscore', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/profile/edit/personal-info-edit-content',
], function(
    // Libs
    _, U,
    // views
    VBasePanel,
    VPersonalInfoEditContent
) {

    var VPersonalSettingsPanel = VBasePanel.extend({
        header: {
            title: "Personal settings",
            subtitle: "Customize your own Totalcoaching",
        },
        // buttons: { back: 'close', },
        content: { edit: VPersonalInfoEditContent },
        tabs: [{ id: 'edit', title: 'Personal information', active: true }],
        defaultView: 'edit',
        initialize: function() {
            var edit = this.getView('edit', { model: this.model });
            this.listenTo(edit, { 'form:success': this.close });
        }

    });

    return VPersonalSettingsPanel;
});

